import { Actions } from 'store/actions';
import { RequestTriggerAction } from 'store/statesHelper';

const getTeacherTraining = (
  pageUID: string
): RequestTriggerAction<Actions.GET_TEACHER_TRAINING> => ({
  type: Actions.GET_TEACHER_TRAINING,
  payload: {
    extraConfig: {
      params: {
        uid: pageUID,
      },
    },
  },
});

export default getTeacherTraining;
